module.exports = __webpack_public_path__ + "taluoshuo.png?0daacd21a18b47c7ae79651302a12d42";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taluoshuo.png
// module id = 235
// module chunks = 1 2 3 6 9 18 26